import React from 'react';
import { branch, compose, renderNothing } from 'recompose';

import InfoToolTip from '../../InfoToolTip';
import * as timeplanUnitStyles from './timeplanUnitStyles.css';
import { useTranslation } from 'react-i18next';

function MissingReportedTimes() {
  const { t } = useTranslation();
  return (
    <div>
      <InfoToolTip title={t("Arbetspass saknas")}>
        {t("Det finns bokade arbetspass på denna dagen, vilka kan avbokas tillsammans med attesteringen.")}
      </InfoToolTip>
      <i className={timeplanUnitStyles.noTimeplanUnits}>{t("Det saknas arbetspass på denna dagen")}</i>
    </div>
  );
}

export default compose(
  branch(({ isNotReported }) => !isNotReported, renderNothing),
)(MissingReportedTimes);
